interface ReviewSpreadsheetViewerProps {
  text: string;
  fileName?: string | null;
}

export function ReviewSpreadsheetViewer({ text, fileName }: ReviewSpreadsheetViewerProps) {
  return (
    <div className="flex h-full w-full flex-col bg-muted/30">
      {fileName && (
        <div className="border-b bg-background/80 px-3 py-1.5 text-xs text-muted-foreground">
          {fileName}
          <span className="ml-2 italic">(extracted text view — original layout not preserved)</span>
        </div>
      )}
      <pre className="flex-1 overflow-auto whitespace-pre p-4 font-mono text-xs leading-relaxed text-foreground">
        {text}
      </pre>
    </div>
  );
}
